import { useEffect } from "react";
import dayjs from "dayjs";
import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState";
import { useTableMapState } from "../TableMapState";
import { useTableMapExport, useWidgetData } from "@/app/widgets/WidgetFactoryContext";

const useExportTableMap = () => {
    const { showingTransactionType, showCrmLeads, zipCodes, models, makes, vehicleTypes, tableView, circleZipCodes } = useTableMapState();

    const { params } = useGlobal();
    const { fetchWidgetExportData } = useWidgetData();
    const { registerExportHandler, unregisterExportHandler } = useTableMapExport();

    useEffect(() => {
        const widgetId = params.widgetId;
        if (!widgetId) return;

        const _vehicleTypes = tableView === 'zipCodesNew' ? ['NEW'] : tableView === 'zipCodesUsed' ? ['USED'] : vehicleTypes
        const _zipCodes = circleZipCodes && circleZipCodes.length > 0 ? circleZipCodes : zipCodes

        const exportHandler = () => {
            fetchWidgetExportData({
                ...params,
                showCrmLeads,
                showingTransactionType,
                zipCodes: _zipCodes,
                models,
                makes,
                vehicleTypes: _vehicleTypes,
                dateRange: {
                    from: dayjs(params.startDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    to: dayjs(params.endDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                },
            } as any);
        };

        registerExportHandler(widgetId, exportHandler);

        return () => {
            unregisterExportHandler(widgetId, exportHandler);
        };
    }, [params.widgetId, params, showCrmLeads, showingTransactionType, zipCodes, models, makes, vehicleTypes, tableView, circleZipCodes, registerExportHandler, unregisterExportHandler]);
};

export default useExportTableMap;
